import { Layout, Row, Col, Typography } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import '../assets/styles/Footer.css';
import AguasIcon from '../assets/images/aguasIcon.webp';
import { useAuth } from '../contexts/authContext/index';

const { Footer } = Layout;
const { Title, Text, Link } = Typography;

export default function CustomFooter() {
    const currentYear = new Date().getFullYear();
    const { currentUser } = useAuth();
    return (
        <Footer className="footer">
            <div className="footer-container">
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={8}>
                        <div className="footer-logo-container">
                            <Title level={4} className="footer-logo-title">
                                <img src={AguasIcon} alt="logo mercado del agua" className='icono' />
                                <span className="footer-logo-span">mercado del agua</span>
                            </Title>
                            <Text className="footer-description">
                                La plataforma donde fabricantes y clientes de piezas para redes de agua se encuentran.
                                Facilitamos la conexión directa, ofreciendo a los fabricantes un espacio para mostrar sus productos y a los clientes un acceso sencillo a una amplia variedad de componentes esenciales.

                            </Text>
                        </div>
                        <div>
                            <Text className="footer-contact-info">
                                <PhoneOutlined className="footer-contact-icon" />
                                03514235308
                            </Text>
                            <Text className="footer-contact-info">
                                <MailOutlined className="footer-contact-icon" />
                                info@mercadodelagua.com
                            </Text>
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={4}>
                    </Col>
                    {/*
                    <Col xs={24} sm={12} lg={4}>
                        <Title level={5} className="footer-column-title">Redes Sociales</Title>
                        <div className="footer-link-container">
                            {['Instagram', 'Facebook', 'Whatsapp'].map(item => (
                                <Link key={item} className="footer-link">{item}</Link>
                            ))}
                        </div>
                    </Col>

                    {/* Dynamic Account Column */}
                    <Col xs={24} sm={12} lg={4}>
                        <Title level={5} className="footer-column-title">
                            {currentUser?.photoURL === 'vendedor' ? 'Mi Negocio' : 'Mi Cuenta'}
                        </Title>
                        <div className="footer-link-container">
                            {(currentUser?.photoURL === 'vendedor' ? [
                                { name: 'Mi perfil', path: '/profile' },
                                { name: 'Mis productos', path: '/profile' },
                                { name: 'Pedidos recibidos', path: '/profile' },
                            ] : [
                                { name: 'Mi cuenta', path: '/profile' },
                                { name: 'Historial de pedidos', path: '/profile' },
                                { name: 'Carrito', path: '/cart' },
                            ]).map(item => (
                                <Link
                                    key={item.name}
                                    className="footer-link"
                                    href={item.path}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                    </Col>
                    {/* Helps Column */}
                    <Col xs={24} sm={12} lg={4}>
                        <Title level={5} className="footer-column-title">Ayudas</Title>
                        <div className="footer-link-container">
                            {[
                                { name: 'Contactar', path: '/contact' },
                                // { name: 'Preguntas frecuentes', path: '/faq' },
                                { name: 'Términos y condiciones', path: '/terms-conditions' },
                                { name: 'Política de privacidad', path: '/privacy-policy' },
                            ].map(item => (
                                <Link
                                    key={item.name}
                                    className="footer-link"
                                    href={item.path}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                    </Col>
                    {/*
                    <Col xs={24} sm={12} lg={4}>
                        <Title level={5} className="footer-column-title">Conócenos</Title>
                        <div className="footer-link-container">
                            {[
                                { name: 'Nosotros', path: '/about' },
                                { name: 'Categorías', path: '/categories' },
                                // { name: 'Blog', path: '/blog' },
                            ].map(item => (
                                <Link
                                    key={item.name}
                                    className="footer-link"
                                    href={item.path}
                                >
                                    {item.name}
                                </Link>
                            ))}

                        </div>
                    </Col>
                    */}
                </Row>
                {/* Copyright */}
                <Row className="footer-copyright">
                    <Col xs={24} lg={12}>
                        <Text className="footer-copyright-text">Mercado del agua © {currentYear}. All Rights Reserved</Text>
                    </Col>
                    <Col xs={24} lg={12} className="footer-developer-info">
                        <Text className="footer-copyright-text">Desarrollado por <a className="link" href="https://innexioar.com" target="_blank" rel="noopener noreferrer">Innexio</a> en Córdoba, Argentina</Text>
                    </Col>
                </Row>
            </div>
        </Footer>
    );
}

